/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import './styles.scss';
import { BadgeProps } from './types';
import { generateID } from '../../base/helper';

const getBadgeClassNames = (
  badgeType: string | undefined,
  isNumber: boolean
): string => {
  if (badgeType === 'DOT') {
    return 'clientos-ui-toolkit-badge--dot';
  } else if (badgeType === 'NUMBER' || isNumber) {
    return 'clientos-ui-toolkit-badge--number';
  } else {
    return 'clientos-ui-toolkit-badge--text';
  }
};

/**
 * UI Toolkit: Badge
 * @public
 */
const Badge: React.FC<BadgeProps> = ({
  content,
  id = generateID('clientos-ui-toolkit-badge'),
  variant = 'DEFAULT',
  badgeType
}) => {
  let limitedContent: string | number = content;
  let isNumber = false;

  if (!badgeType) {
    isNumber = /^\d+(\.\d+)?$/.test(String(content));
    if (typeof content === 'number' && content > 99) {
      limitedContent = '99+';
    }
  }

  const badgeClassNames = getBadgeClassNames(badgeType, isNumber);

  return (
    <div
      className={`clientos-ui-toolkit-badge ${variant.toLowerCase()} ${badgeClassNames}`}
      id={id}
    >
      {badgeType !== 'DOT' ? limitedContent : ''}
    </div>
  );
};

export default Badge;
